import { render, staticRenderFns } from "./playrecord.vue?vue&type=template&id=239f5744&"
import script from "./playrecord.vue?vue&type=script&lang=ts&"
export * from "./playrecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports